'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { focusOutline } from '../../utility-classes';
import { Button, buttonSizeToHeight } from '../Button';
export const IconButton = styled(({ variant = 'black-on-transparent', borderless = true, ...props }) => (_jsx(Button, { variant: variant, borderless: borderless, ...props }))) `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  min-height: ${o => buttonSizeToHeight(o.size ?? 'medium')};
  min-width: ${o => buttonSizeToHeight(o.size ?? 'medium')};
  width: unset;
  height: unset;
  padding: ${o => o.theme.spacing(o.size === 'small' ? 1 : 2)};
  ${o => (o.flushLeft ? `margin-left: -${o.theme.spacing(o.size === 'small' ? 1 : 2)};` : null)}
  ${o => (o.flushRight ? `margin-right: -${o.theme.spacing(o.size === 'small' ? 1 : 2)};` : null)}
  ${o => (o.flushTop ? `margin-top: -${o.theme.spacing(o.size === 'small' ? 1 : 2)};` : null)}
  ${o => (o.flushBottom ? `margin-bottom: -${o.theme.spacing(o.size === 'small' ? 1 : 2)};` : null)}
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;

  ${focusOutline};
  svg {
    min-height: ${o => (o.size === 'small' ? '13px' : '16px')};
    min-width: ${o => (o.size === 'small' ? '13px' : '16px')};
  }
`;
//# sourceMappingURL=IconButton.js.map